//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TreeseLect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "./IconSelect/index";
export default {
  name: "AddOrEdit",
  $dictKeyList: [
    {
      key: "9",
      name: "菜单管理系统标识",
    },
  ],
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: "add",
    },
    menuList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    munuData: {
      type: Object,
      default: () => {},
    },
  },
  components: { TreeseLect, IconSelect },
  data() {
    return {
      form: {
        parentId: null,
        orderNum: "",
        urlAddress: "",
        icon: "",
        hideFlag: false,
        outsideUrlFlag: false,
        menuName: "",
        permission: "",
        menuType: 3,
        pullDownFlag: false,
        systemType: "",
        showLeftFlag: true,
        businessType: "",
        redirect: "",
      },
      btnCode: "",
      rules: {
        menuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "菜单顺序不能为空", trigger: "blur" },
        ],
        systemType: [
          { required: true, message: "系统标识不能为空", trigger: "blur" },
        ],
      },
      sys_normal_disable: [
        { value: true, label: "展示" },
        { value: false, label: "隐藏" },
      ],
      sys_show_hide: [
        { value: true, label: "是" },
        { value: false, label: "否" },
      ],
      iconObj: {},
      iconLoad: 0,
    };
  },
  computed: {},
  watch: {
    "form.menuType"(n) {
      if (n == 4) {
        this.form.hideFlag = true;
      }
    },
  },
  methods: {
    /**
     * @description: 修复无法输入的问题
     * @Author: yangsibo
     * @Date: 2022-07-12 11:10:21
     * @return {*}
     */
    onInput() {
      this.$forceUpdate();
    },
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2023-03-31 11:27:51
     * @return {*}
     */
    clearIconObj() {
      this.iconObj = {};
      this.form.icon = "";
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-02 17:10:24
     * @param {*} node 选中节点
     * @return {*}
     */
    selectTreeNode(node) {
      this.form.systemType = `${node.systemType}`;
      this.form.childSystemType = `${node.childSystemType}`;
    },
    // 选择图标
    selected(icon, type) {
      this.iconObj = icon ? icon : {};
      this.form.icon = icon ? icon.icon : "";
      this.iconLoad = type;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "showAddOrEdit");
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.menuName,
        children: node.children,
        // isDisabled: node.menuType == 4,
      };
    },
    /**
     * @description: 新增菜单
     * @Author: yangsibo
     * @Date: 2022-05-30 13:57:17
     */
    async insertSMenu() {
      if (this.form.menuType == 4) {
        this.form.logo = this.btnCode;
      }
      this.form.parentId = this.form.parentId ? this.form.parentId : "0";
      let { status } = await this.$http.menu.insertSMenu(this.form);
      if (status == 1) {
        this.$message({
          type: "success",
          message: "新增菜单成功",
          duration: 2000,
        });
        this.$emit("getMenuList");
        this.close();
      }
    },
    /**
     * @description: 保存表单
     * @Author: yangsibo
     * @Date: 2022-05-26 17:13:49
     */
    handleSaveAddOrEdit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.type == "add") {
            this.insertSMenu();
          } else {
            this.updateSMenuById();
          }
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 获取菜单详情
     * @Author: yangsibo
     * @Date: 2022-05-30 11:38:32
     */
    async selectSMenuDetailById() {
      try {
        let { data } = await this.$http.menu.selectSMenuDetailById({
          id: this.munuData.id,
        });
        data.parentId = data.parentId === "0" ? null : data.parentId;
        this.btnCode = data.logo ? data.logo : "";
        Object.assign(this.form, data);
        this.form.systemType = `${this.form.systemType}`;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 编辑菜单
     * @Author: yangsibo
     * @Date: 2022-05-30 13:55:34
     */
    async updateSMenuById() {
      try {
        let params = JSON.parse(JSON.stringify(this.form));
        params.parentId = params.parentId ? params.parentId : "0";
        if (this.form.menuType == 4) {
          params.logo = this.btnCode;
        }
        let { status } = await this.$http.menu.updateSMenuById(params);
        if (status == 1) {
          this.$message({
            type: "success",
            message: "编辑菜单成功",
            duration: 2000,
          });
          this.$emit("getMenuList");
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {},
  mounted() {
    if (this.type == "edit") {
      this.selectSMenuDetailById();
    }
  },
};
